import { Duration } from "luxon";

export function formatDurationLimitLabel(duration: Duration): string {
  const hours = duration.as("hours");
  if (Number.isFinite(hours) && Math.abs(hours - Math.round(hours)) < 1e-6) {
    const wholeHours = Math.round(hours);
    return `${wholeHours}-hour limit`;
  }

  const minutes = Math.round(duration.as("minutes"));
  return `${minutes}-minute limit`;
}

export function formatElapsedDuration(seconds: number | null): string | null {
  if (seconds == null) return null;
  const duration = Duration.fromObject({ seconds }).shiftTo("hours", "minutes", "seconds");
  const hours = Math.floor(seconds / 3600);
  const format = hours > 0 ? "hh:mm:ss" : "mm:ss";
  return duration.toFormat(format);
}
